import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
};

export const GetSCVCountDashboard = async (
    StartDate,
    endDate,
    ZoneId,
    CircleId,
    WardId,
    ShiftId,
    RouteID,
    OwnerTypeId
) => {
    try {
        let apiUrl =
            API_BASE_URL1 +
            "DashboardReport/SCVCountDashboard?";

        // Append StartDate and endDate
        if (StartDate && endDate) {
            apiUrl += `StartDate=${StartDate}&EndDate=${endDate}`;
        }

        // Append ZoneId if not null
        if (ZoneId !== null) {
            apiUrl += `&ZoneId=${ZoneId}`;
        }

        // Append CircleId if not null
        if (CircleId !== null) {
            apiUrl += `&CircleId=${CircleId}`;
        }

        // Append WardId if not null
        if (WardId !== null) {
            apiUrl += `&WardId=${WardId}`;
        }

        // Append RouteID if not null
        if (RouteID !== null) {
            apiUrl += `&RouteID=${RouteID}`;
        }

        // Append OwnerTypeId if not null
        if (OwnerTypeId !== null) {
            apiUrl += `&OwnerTypeId=${OwnerTypeId}`;
        }

        // Append ShiftId if not null
        if (ShiftId !== null) {
            apiUrl += `&ShiftId=${ShiftId}`;
        }

        const token = getToken(); // Get the token
        const response = await axiosInstance.get(apiUrl, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response;
    } catch (error) {
        throw error;
    }
};
